module.exports = __webpack_public_path__ + "3c742d15f36ded201c503b9454f163e5.jpg";